import { PatientCaseWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseDateQueryParam } from '@/utils/query-params/parseDateQueryParam';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminCaseListQueryParams = (pageSize: number, prefix: string | null) => {
  const queryObject = useQueryParams(
    [
      QUERY_PARAM_GLOBAL_FILTER_KEY,
      'createdAt',
      'name',
      'purchaseOrder',

      'clientName',
      'caseClusterName',
    ],
    prefix
  );

  const { q, createdAt, name } = queryObject;
  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const where: PatientCaseWhereInput = {
    AND: [
      q
        ? {
            OR: [
              { id: parseStringQueryParam(q) },
              { name: parseStringQueryParam(q) },
              {
                legacyCaseId: parseStringQueryParam(q),
              },
            ],
          }
        : {},
      {
        name: parseStringQueryParam(name),
        creationDate: parseDateQueryParam(createdAt),
        purchaseOrderNbr: parseStringQueryParam(queryObject.purchaseOrder),
      },
      queryObject.clientName
        ? {
            client: {
              is: {
                name: parseStringQueryParam(queryObject.clientName),
              },
            },
          }
        : {},
      queryObject.caseClusterName
        ? {
            caseClusters: {
              some: {
                name: parseStringQueryParam(queryObject.caseClusterName),
              },
            },
          }
        : {},
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
